import { computed } from '@ember/object';
import { ternary } from '@intercom/pulse/lib/computed-properties';
import InboundActions from '@intercom/embercom-composer/mixins/inbound-actions';
import ComponentPositioningMixin from '@intercom/embercom-composer/components/mixins/component-positioning';
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import $ from 'jquery';
import { reads } from '@ember/object/computed';
import { schedule } from '@ember/runloop';
import Em from 'ember';
export default Em.Component.extend(InboundActions, ComponentPositioningMixin, {
  classNames: ['composer-media-inserter-container'],
  attributeBindings: ['style'],
  classNameBindings: ['isWithinViewport::is-out-of-view'],
  isWithinViewport: reads('hoverCoordinates.isWithinViewport'),
  selectedInserter: null,
  isMinimized: true,
  mode: 'selector',
  modeComponent: computed('mode', function () {
    return `media-inserter-${this.mode}`;
  }),
  dividerShowStyle: ternary('showDivider', 'block', 'none'),
  blockDividerStyle: computed('width', 'verticalOffset', 'dividerShowStyle', function () {
    return `<style>.composer-media-inserter-container:after{left:${this.width}px;top:calc(50% - ${this.verticalOffset}px); display: ${this.dividerShowStyle};}</style>`;
  }),
  didInsertElement() {
    this._super(...arguments);
    this.set('showDivider', true);
    this.setDimensions();
  },
  willDestroyElement() {
    this._super(...arguments);
    this.set('showDivider', true);
    this.enableHoverUpdates?.();
  },
  _updateDimensionsOnModeChange: Em.observer({
    dependentKeys: ['mode'],
    fn() {
      this.setDimensions();
    },
    sync: true
  }),
  setDimensions() {
    schedule('afterRender', this, function () {
      if (Em.isPresent($(this.element))) {
        let $visibleComponent = $('div', this.element).first();
        let $composer = $(this.element).closest('.embercom-composer').find('.embercom-composer-editor');
        this.setProperties({
          width: $visibleComponent.outerWidth(true),
          height: $(this.element).outerHeight(true),
          composerWidth: $composer.outerWidth()
        });
      }
    });
  },
  top: Em.computed('height', 'hoverCoordinates.top', function () {
    return this.get('hoverCoordinates.top') - this.get('height') / 2;
  }),
  left: Em.computed('width', 'hoverCoordinates.left', function () {
    return this.get('width') * -1 + this.get('hoverCoordinates.left');
  }),
  style: Em.computed('top', 'left', 'verticalOffset', function () {
    let marginLeftOffset = 7;
    let topPlusVerticalOffset = this.get('top') + this.get('verticalOffset');
    return sanitizeHtml(`top: ${topPlusVerticalOffset}px; left: ${this.get('left')}px; width: ${this.get('composerWidth') + marginLeftOffset}px`);
  }),
  verticalOffset: Em.computed('top', 'isMinimized', function () {
    if (!this.get('isMinimized')) {
      let top = this.get('top');
      let verticalOffset = this._verticalOffsetForOverflowParent(top, $(this.element));
      this.positionPointer(verticalOffset);
      return verticalOffset;
    } else {
      return 0;
    }
  }),
  actions: {
    openFileDialog(uploadType) {
      this.openFileDialog?.(uploadType);
      this.send('minimize');
    },
    maximize() {
      this.set('isMinimized', false);
      this.setDimensions();
      this.disableHoverUpdates();
    },
    insertBlock(block, options) {
      this.insertBlock?.(block, options);
      this.send('minimize');
    },
    createBlock(type, data) {
      let options = Object.assign({
        index: this.get('hoverCoordinates.insertionIndex')
      }, data);
      this.createBlock?.(type, options);
      this.send('minimize');
    },
    insertCharacter(character) {
      this.insertCharacter?.(character);
      this.send('minimize');
    },
    minimize() {
      if (!this.get('isDestroying')) {
        this.set('isMinimized', true);
        this.set('mode', 'selector');
        this.set('selectedInserter', null);
        this.setDimensions();
        this.enableHoverUpdates?.();
      }
    },
    selectInserter(selectedInserter) {
      this.set('selectedInserter', selectedInserter);
      this.setDimensions();
    }
  }
});